import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@onecpa/ui/tokens.css";
import { App } from "./App.js";
import { AuthProvider } from "./auth/AuthProvider.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Financial data: never show a stale number without checking. Short stale
      // time plus refetch on focus means switching back to a tab shows current
      // state rather than yesterday's reporting matrix.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
